<template>
  <div class="home">
    <template v-if="isSeller()">
      <SellerView></SellerView>
    </template>
    <template v-else>
      <HomeView></HomeView>
    </template>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'

export default {
  name: 'Home',
  components: {
    HomeView: () => import('../components/homepage/HomeView.vue'),
    SellerView: () => import('@/components/homepage/SellerView.vue'),
  },
}
</script>
